import React, { useState, useEffect, useRef } from 'react';
import { Send } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

export default function MessagesPage() {
  const { api, user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [content, setContent] = useState('');
  const [sending, setSending] = useState(false);
  const bottomRef = useRef(null);

  const loadMessages = () => api('get', '/api/portal/messages').then(r => setMessages(r.data.messages || []));
  useEffect(() => { loadMessages(); const t = setInterval(loadMessages, 15000); return () => clearInterval(t); }, []);
  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    setSending(true);
    try {
      await api('post', '/api/portal/messages', { content });
      setContent('');
      loadMessages();
    } catch { toast.error('Verzenden mislukt'); }
    finally { setSending(false); }
  };

  return (
    <div className="max-w-3xl flex flex-col" style={{ height: 'calc(100vh - 140px)' }}>
      <h1 className="text-2xl font-bold text-white mb-4">Berichten</h1>
      <div className="flex-1 bg-[#0f172a] rounded-2xl border border-white/5 flex flex-col overflow-hidden">
        {/* Messages */}
        <div className="flex-1 overflow-y-auto p-5 space-y-4">
          {messages.length === 0 ? (
            <div className="text-center py-12 text-[#475569]">Nog geen berichten. Stel hier uw vragen aan ons team.</div>
          ) : (
            [...messages].reverse().map(m => {
              const isMe = m.from_role !== 'admin';
              return (
                <div key={m.id} className={`flex ${isMe ? 'justify-end' : 'justify-start'}`}>
                  <div className={`max-w-xs lg:max-w-md px-4 py-3 rounded-2xl text-sm ${
                    isMe ? 'bg-[#D4A017] text-[#0f172a]' : 'bg-white/10 text-white'
                  }`}>
                    {!isMe && <p className="text-[#D4A017] text-xs font-bold mb-1">IMPERIA AI</p>}
                    <p className="leading-relaxed">{m.content}</p>
                    <p className={`text-xs mt-1 opacity-60`}>{m.created_at?.slice(11, 16)}</p>
                  </div>
                </div>
              );
            })
          )}
          <div ref={bottomRef} />
        </div>
        {/* Input */}
        <div className="border-t border-white/5 p-4">
          <form onSubmit={sendMessage} className="flex gap-3">
            <input value={content} onChange={e => setContent(e.target.value)} placeholder="Typ een bericht..."
              className="flex-1 bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-[#475569] focus:outline-none focus:border-[#D4A017] text-sm" />
            <button type="submit" disabled={sending || !content.trim()}
              className="bg-[#D4A017] hover:bg-[#B8860B] text-[#0f172a] font-bold px-4 py-3 rounded-xl transition-all disabled:opacity-60">
              <Send size={16} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
